import { useMutation } from "react-query";
import useApi from "./useApiRequest";

export const ValidateDataUser = ()  => {
    const api = useApi();

    const mutate = async (params) => {
        const data  = await api.noSessionPost(`/usuarios/validate-user`, params, {
            dataType: "json",
            hasFormData: false,
            hasCustomUrl: false,
        });
        return data.data;
    };

    const mutation = useMutation(mutate);

    return {
        validateDataUserMutation: mutation.mutate,
    };
}

export const ResetPassword = ()  => {
    const api = useApi();

    const mutate = async (params) => {
        const data  = await api.noSessionPost(`/usuarios/password/reset`, params, {
            dataType: "json",
            hasFormData: false,
            hasCustomUrl: false,
        });
        return data.data;
    };

    const mutation = useMutation(mutate);

    return {
        resetPasswordMutation: mutation.mutate,
    };
}